import { readonly, ref, toValue } from 'vue'
import { getCurrentScope, onScopeDispose } from 'vue'

export function useTimeout(
  cb,
  interval,
  { immediate = true } = {}
) {
  const isPending = ref(false)
  let timer = null

  function clear() {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  function stop() {
    isPending.value = false
    clear()
  }

  function start(...args) {
    clear()
    isPending.value = true
    timer = setTimeout(() => {
      isPending.value = false
      timer = null

      cb(...args)
    }, toValue(interval))
  }

  if (immediate) {
    isPending.value = true
    start()
  }

  if (getCurrentScope()) {
    onScopeDispose(stop)
  }

  return {
    isPending: readonly(isPending),
    start,
    stop
  }
}
